export enum TipsheetCardVariant {
  // NOTE Keep names lowercased so that class names don't break
  ACCENT = 'accent',
  GREEN = 'green',
  LIGHT = 'light',
}
